import React from 'react'

export default function Heading({text}) {
  return (
    <h1 className='headings'>{text}</h1>
  )
}
